import { fg } from '@confluence/feature-gating';

import { useNav4OptOut } from './useNav4OptOut';

export const useIsNav4Enabled = () => {
	const { nav4OptOut } = useNav4OptOut();
	return fg('confluence_nav_4') && !nav4OptOut;
};
